import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IPreferencesService = ( createDecorator('preferencesService'));
export { IPreferencesService };
